var React = require('react');

function CloseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.8559 0L16 1.14411C13.5439 3.46461 11.034 5.90669 8.47036 8.47036L8.94279 8.00131C11.3426 10.3933 13.695 12.6781 16 14.8559L14.8559 16C12.5354 13.5439 10.0933 11.034 7.52965 8.47036L7.99869 8.94279C5.60674 11.3426 3.32188 13.695 1.14411 16L0 14.8559C2.4561 12.5354 4.96598 10.0933 7.52965 7.52965L7.05721 7.99869C4.65744 5.60674 2.30503 3.32188 0 1.14411L1.14411 0C3.46461 2.4561 5.90669 4.96598 8.47036 7.52965L8.00131 7.05721C10.3933 4.65744 12.6781 2.30503 14.8559 0Z"}));
}

CloseInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"black"};

module.exports = CloseInline;

CloseInline.default = CloseInline;
